import { axios } from '@Root/API'

export const getByName = institutionName => {
	return axios.get(`institutions/${institutionName}/name`)
}
